export class ProductFilter {
  public brand: any;
  public subbrand: any;
  public line: any;
  public format: any;
  constructor() {
    this.subbrand = '';
    this.line = '';
    this.format = '';
    this.brand = '';
  }
}
